import React, { useId } from 'react';
import { cn } from '@/utils';
import { useDeviceWidth } from '@/hooks/useDeviceWidth';

type LoaderSize = 'sm' | 'md' | 'lg';

interface BetExLoaderProps {
  size?: LoaderSize;
  className?: string;
}

const sizeConfig = {
  sm: { container: 110, inner: 100, logo: 80, stroke: 10 },
  md: { container: 180, inner: 165, logo: 135, stroke: 15 },
  lg: { container: 240, inner: 220, logo: 170, stroke: 16 },
};

const BetExLoader: React.FC<BetExLoaderProps> = ({ size = 'md', className }) => {
  const width = useDeviceWidth();
  const config = width <= 640 ? sizeConfig.sm : sizeConfig[size];
  const gradientId = useId();

  return (
    <div
      className={cn(
        'fixed inset-0 z-[9999] flex items-center justify-center bg-black/30 backdrop-blur-md',
        className
      )}
    >
      <div
        className="relative flex items-center justify-center"
        style={{
          width: config.container,
          height: config.container,
        }}
      >
        <svg
          className="absolute top-0 left-0 w-full h-full animate-spin"
          style={{ animationDuration: '1.4s', animationTimingFunction: 'linear' }}
          viewBox="0 0 200 200"
        >
          <defs>
            <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stopColor="#D0922F" />
              <stop offset="100%" stopColor="#855E1E" />
            </linearGradient>
          </defs>

          <circle
            cx="100"
            cy="100"
            r="100"
            fill="none"
            stroke="#1a1a1a"
            strokeWidth={config.stroke - 4}
          />

          <circle
            cx="100"
            cy="100"
            r="100"
            fill="none"
            stroke={`url(#${gradientId})`}
            strokeWidth={config.stroke}
            strokeLinecap="round"
            strokeDasharray="565"
            strokeDashoffset="100"
            transform="rotate(-90 100 100)"
          />
        </svg>

        <div
          className="relative z-10 rounded-full bg-black flex items-center justify-center"
          style={{
            width: config.inner,
            height: config.inner,
          }}
        >
          <img src="/images/login/logo.png" alt="logo" style={{ width: config.logo }} />
        </div>
      </div>
    </div>
  );
};

export default BetExLoader;
